<template>
  <slot
    v-if="isWebCallbackEnabled"
    :open="openWebCallBackorderModal"
    :list="getActiveBackListFromArray"
  />
</template>

<script setup lang="ts">
import { useDialog } from '@wui/common-library'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { WebCallBackorder } from '@/features/CallBack'

import { useCallBack } from '@/entities/webCallBackOrder'

import { useUserFeatures } from '@/shared/composables/user-features'
import { FeaturesNames } from '@/shared/types/settings'
import { fromPServedUser } from '@/shared/utils/uri'

const props = defineProps<{
  pServed: string
}>()

const { showDialog } = useDialog()
const { hasFeature } = useUserFeatures()
const isWebCallbackEnabled = computed(() => hasFeature(FeaturesNames.WEB_CALL_BACKORDER))

const { getActiveBackListFromArray } = storeToRefs(useCallBack())

const openWebCallBackorderModal = () => {
  if (!isWebCallbackEnabled.value) {
    return
  }

  showDialog(WebCallBackorder, {
    contactNumber: fromPServedUser(props.pServed),
    hasOverlay: true,
    isDialog: true,
    isModal: true,
  })
}
</script>
